import React from 'react';

import {
    mapPropertiesToSelectedVariation,
    getProductImages,
} from '../utils/configUtils';
import { getPropertiesFromCart } from '../utils/shopify';

import ProductStage from './shared/ProductStage';

class Preview extends React.Component {
    state = {
        selectedVariation: null,
    };

    componentDidMount() {
        const { previewKey } = this.props;

        if (previewKey) {
            getPropertiesFromCart(previewKey).then(properties => {
                const selectedVariationFromCart = mapPropertiesToSelectedVariation(
                    properties,
                    this.props.config
                );

                this.setState({
                    selectedVariation: selectedVariationFromCart,
                });
            });
        }
    }

    render() {
        const { selectedVariation } = this.state;

        if (!selectedVariation) return null;

        return (
            <ProductStage
                size="120px"
                color="transparent"
                productImages={getProductImages(
                    this.props.config,
                    selectedVariation
                )}
            />
        );
    }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/components/Preview.js